import React from 'react';
import Slider from 'react-slick';
import { INVESTMENT_SLIDER } from '../../../Data/DashBoard/Default/SliderData';
import { InvestmentOption } from '../../../Data/DashBoard/Default/SliderConfig';
import { P, H3 } from '../../../AbstractElements';
import { Col } from 'reactstrap';
import PrettyNumbers from '../../../Utils/PrettyNumbers';

const InvestmentSlider = () => {
  return (
    <Col xl='12'>
      <Slider className='items-slider' {...InvestmentOption}>
        {INVESTMENT_SLIDER.map((item, i) => (
          <Col xl='2' lg='4' sm='4' key={i} className='box-col-33'>
            <div className='card investment-sec'>
              <div className='animated-bg'>
                <i />
                <i />
                <i />
              </div>
              <div className='card-body'>
                <div className='icon'>{item.icon}</div>
                <P>{item.title}</P>
                <H3>
                  $<PrettyNumbers currency={false}>{item.price}</PrettyNumbers>
                </H3>
              </div>
            </div>
          </Col>
        ))}
      </Slider>
    </Col>
  );
};

export default InvestmentSlider;
